import { useBreakpointValue } from '@chakra-ui/react';

/**
 * Returns true if the viewport is currently considered 'mobile'. Recalculates when viewport size
 * changes.
 */
export const useIsMobile = () =>
  useBreakpointValue([true, null, null, false], { ssr: false });
